"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialize_param_1 = require("./serialize-param");
var del_param_1 = require("./del-param");
var all_keys_1 = require("./all-keys");
var is_object_1 = require("./is-object");
/**
 * 往 URL 上添加参数
 *
 * @param {any} params 需要添加的参数
 * @param {string} url 需要添加参数的 URL
 * @returns
 */
function addParam(params, url) {
    if (!is_object_1.default(params))
        return url;
    var names = all_keys_1.default(params);
    if (names.length === 0)
        return url;
    url = del_param_1.default(names, url);
    var postfix = serialize_param_1.default(params);
    url += /(\?|&)$/.test(url) ? '' + postfix : /\?/.test(url) ? '&' + postfix : '?' + postfix;
    return url;
}
exports.default = addParam;
//# sourceMappingURL=add-param.js.map